define('dcf-toggle-button',["exports", "./dcf-utility"], function (_exports, _dcfUtility) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DCFToggleButton = void 0;

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

  var DCFToggleButton = /*#__PURE__*/function () {
    // Set up the button
    function DCFToggleButton(toggleButtons) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, DCFToggleButton);

      // Create the events for toggling the button and element
      this.toggleButtonOn = new Event(DCFToggleButton.events('toggleButtonOn'));
      this.toggleButtonOff = new Event(DCFToggleButton.events('toggleButtonOff'));
      this.toggleElementOn = new Event(DCFToggleButton.events('toggleElementOn'));
      this.toggleElementOff = new Event(DCFToggleButton.events('toggleElementOff')); // Set up key that toggle, open, and close

      this.toggleKeys = options.toggleKeys;

      if (this.toggleKeys === undefined) {
        this.toggleKeys = [];
      }

      this.onKeys = options.onKeys;

      if (this.onKeys === undefined) {
        this.onKeys = [];
      }

      this.offKeys = options.offKeys;

      if (this.offKeys === undefined) {
        this.offKeys = [];
      } // These keys will always work


      this.toggleKeys.push('space');
      this.offKeys.push('escape'); // Create a random ID for the button

      this.uuid = _dcfUtility.DCFUtility.uuidv4(); // Store the button inputted (always will be an array)

      this.toggleButtons = toggleButtons;

      if (NodeList.prototype.isPrototypeOf(this.toggleButtons)) {
        this.toggleButtons = Array.from(this.toggleButtons);
      } else if (!Array.isArray(this.toggleButtons)) {
        this.toggleButtons = [this.toggleButtons];
      }
    } // The names of the events to be used easily


    _createClass(DCFToggleButton, [{
      key: "initialize",
      value: // Initialize the buttons that were inputted in the constructor
      function initialize() {
        var _this = this;

        // loops through each one
        this.toggleButtons.forEach(function (toggleButton) {
          // Gets the info for the thing the button is toggling
          var toggleElementId = toggleButton.dataset.controls;
          var toggleElement = document.getElementById(toggleElementId);

          if (toggleElement === null) {
            throw new Error('Missing Toggle Element');
          } // Gets the info for setting up the button


          var toggleButtonIdPostfix = toggleButton.dataset.postfix;

          if (toggleButtonIdPostfix === undefined) {
            toggleButtonIdPostfix = '';
          }

          var toggleButtonStartExpanded = toggleButton.dataset.startExpanded;

          if (toggleButtonStartExpanded === undefined) {
            toggleButtonStartExpanded = 'false';
          } // if it does not have an ID set it to a random one


          if (toggleButton.id === '') {
            toggleButton.id = _this.uuid.concat('-button-', toggleButtonIdPostfix);
          } // set the attributes for the button


          toggleButton.setAttribute('aria-controls', toggleElementId); // set the attributes for the thing being toggled

          if (toggleElement.getAttribute('aria-labelledby') !== null && toggleElement.getAttribute('aria-labelledby') !== toggleButton.id) {
            throw new Error('Toggle Element Already Has Toggle Button');
          }

          toggleElement.setAttribute('aria-labelledby', toggleButton.id); // ToggleSwitched will set many of the other attributes and styles

          var expandedState = toggleButtonStartExpanded === 'true' ? 'open' : 'close';

          _this.toggleSwitched(toggleButton, toggleElement, expandedState); // set up the event listeners for the button and element


          _this.eventListeners(toggleButton, toggleElement);
        });
      } // sets up the event listeners for the button

    }, {
      key: "eventListeners",
      value: function eventListeners(toggleButton, toggleElement) {
        var _this2 = this;

        // Toggle the element when button is clicked
        toggleButton.addEventListener('click', function (clickEvent) {
          _this2.toggleSwitched(toggleButton, toggleElement);

          clickEvent.preventDefault();
        }, false); // Show/hide element when the 'space' key is pressed
        // Hide element when the `escape` is pressed

        toggleButton.addEventListener('keydown', function (keydownEvent) {
          _this2.toggleKeys.forEach(function (key) {
            if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents(key))) {
              keydownEvent.preventDefault();

              _this2.toggleSwitched(toggleButton, toggleElement);
            }
          });

          _this2.onKeys.forEach(function (key) {
            if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents(key))) {
              keydownEvent.preventDefault();

              _this2.toggleSwitched(toggleButton, toggleElement, 'open');
            }
          });

          _this2.offKeys.forEach(function (key) {
            if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents(key))) {
              keydownEvent.preventDefault();

              _this2.toggleSwitched(toggleButton, toggleElement, 'close');
            }
          });
        }, false);
      } // Handles the logic for the button
      // This will only call the animations

    }, {
      key: "toggleSwitched",
      value: function toggleSwitched(toggleButton, toggleElement) {
        var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        // Gets the labels for the button
        var toggleButtonLabelOn = toggleButton.dataset.labelOn;
        var toggleButtonLabelOff = toggleButton.dataset.labelOff; // Toggled On

        if ((toggleButton.ariaExpanded === 'false' || toggleButton.ariaExpanded === null) && (state === 'open' || state === '')) {
          toggleButton.setAttribute('aria-expanded', 'true');
          toggleButton.setAttribute('aria-label', toggleButtonLabelOff);
          toggleButton.dispatchEvent(this.toggleButtonOn);
          toggleElement.setAttribute('aria-hidden', 'false');
          toggleElement.classList.remove('dcf-opacity-0', 'dcf-pointer-events-none');
          toggleElement.classList.add('dcf-opacity-1', 'dcf-pointer-events-auto');
          toggleElement.dispatchEvent(this.toggleElementOn);
          toggleElement.focus(); // Toggle Off
        } else if ((toggleButton.ariaExpanded === 'true' || toggleButton.ariaExpanded === null) && (state === 'close' || state === '')) {
          toggleButton.setAttribute('aria-expanded', 'false');
          toggleButton.setAttribute('aria-label', toggleButtonLabelOn);
          toggleButton.dispatchEvent(this.toggleButtonOff);
          toggleElement.setAttribute('aria-hidden', 'true');
          toggleElement.classList.remove('dcf-opacity-1', 'dcf-pointer-events-auto');
          toggleElement.classList.add('dcf-pointer-events-none', 'dcf-opacity-0');
          toggleElement.dispatchEvent(this.toggleElementOff);
        }
      }
    }], [{
      key: "events",
      value: function events(name) {
        var events = {
          toggleButtonOn: 'toggleButtonOn',
          toggleButtonOff: 'toggleButtonOff',
          toggleElementOn: 'toggleElementOn',
          toggleElementOff: 'toggleElementOff'
        };
        Object.freeze(events);
        return name in events ? events[name] : undefined;
      }
    }]);

    return DCFToggleButton;
  }();

  _exports.DCFToggleButton = DCFToggleButton;
});

